import React from 'react';
import { styled } from 'styled-components';
import { LoadingBar } from './LoadingBar';
import { useLoadingBarState } from './LoadingBarProvider';
import { zIndex } from '../../../../play-core/styles/z-index';
import { jsx as _jsx } from "react/jsx-runtime";
export const GlobalLoadingBar = () => {
  const isLoading = useLoadingBarState();
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(LoadingBar, {
      isLoading: isLoading,
      zIndex: zIndex.aboveDialog
    })
  });
};
const Container = styled.div.withConfig({
  displayName: "GlobalLoadingBar__Container",
  componentId: "sc-1kg8t9a-0"
})(["position:fixed;top:0;left:0;right:0;z-index:", ";"], zIndex.aboveDialog);